import React, {Fragment} from "react";
import htmlParser from "he";
import {capitalizeFirstCharacter, personalizeResponse} from "_helpers";
import moment from "moment-timezone";
import {CircularProgress} from "@mui/material";
import ProactiveMetricsMessageIframe from "./Utilities/ProactiveMetricsMessageIframe";
import ProactiveMetricMessageShopify from "./Utilities/ProactiveMetricMessageShopify";
import {isShopifyAndFirstIncomingMessage} from "./ProactiveMetricsDetailUtil";
import styles from "./Utilities/styles.module.css";

const ProactiveMetricsConversation = ({message, loadingConversation, index, messageSource, isFirstIncomingMessaging}) => {
    const messageAuthor = message?.authorName;
    const zone_name =  moment.tz.guess();
    const timezone = moment.tz(zone_name).zoneAbbr();
    const dateCreated =  message?.dateCreatedFromSource || message?.dateCreated;
    const text = htmlParser.decode(personalizeResponse(message.text, messageAuthor, "", null));

    return(
        <Fragment>
            {loadingConversation &&
                <div className={styles.msgListLoaderContainer}>
                    <div className={styles.msgListInner}>
                        <CircularProgress sx={{color: '#003300'}}/>
                    </div>
                </div>
            }

            {!loadingConversation &&
                <>
                    {isShopifyAndFirstIncomingMessage(messageSource, isFirstIncomingMessaging) ?
                        <ProactiveMetricMessageShopify message={message} messageAuthor={messageAuthor} /> :
                        <div className={styles.conversationContainer}>
                            <div className="md-msg-container">
                                <div className="conversation-item-container">
                                    <div className="conversation-item-row">
                                        <div className={styles.msgMetaDetails}>
                                            <div className={styles.msgAuthor}>{messageAuthor}</div>
                                            <div className={styles.metricsDetailDateTime}>
                                                <span className="metrics-detail-date">
                                                    {capitalizeFirstCharacter(moment.utc(dateCreated).fromNow())}
                                                    {`(${moment(dateCreated).format('MMMM Do YYYY HH:mm')} ${timezone})`}
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className={`${styles["metricsDetailFullMsg"]} ${
                                                message.direction.toLowerCase() === "outgoing" ? styles.outgoingMsg : ""
                                            }`}
                                        >
                                            <ProactiveMetricsMessageIframe text={text} index={index} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </>
            }
        </Fragment>
    )
}

export default ProactiveMetricsConversation;

